import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The header back button: one step back in the app's own history, or Home
 * when there is none.
 *
 * A link opened directly (a shared activity, a new tab) has no in-app entry
 * behind it, so `navigate(-1)` silently did nothing (#100, Geri's report).
 * React Router keeps its own position in `history.state.idx`: 0 means this is
 * the first page of the app in this tab.
 */
export function useGoBack(fallback = '/'): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: unknown } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [fallback, navigate]);
}
